/**
 * Marka Talepleri — /talepler. Sadece efe@heyglowy.com.
 * Müşteri maillerinden çıkarılmış bekleyen işler, marka marka.
 * İçerik pakete gömülmez, /api/marka-talepleri'den gelir (backend e-posta kilitli).
 */
import React, { useEffect, useMemo, useState } from 'react';
import { Inbox, Mail, ArrowRight, Users, RefreshCw } from 'lucide-react';
import { apiFetch } from '../utils/apiFetch';

const API = 'https://api.glowytics.com/api/marka-talepleri';

const T = {
  kart: '#FFFFFF', cizgi: '#E5E7EB', cizgi2: '#F3F4F6', yuzey: '#F8FAFF',
  metin: '#111827', metin2: '#374151', metin3: '#6B7280', mavi: '#436AEB',
};

const DURUM = {
  bizde:   { ad: 'Bizde',                    kisa: 'Bizden cevap/iş bekleniyor', renk: '#DC2626', zemin: '#FEF2F2' },
  bildir:  { ad: 'Yapıldı, bildirilmedi',    kisa: 'İş bitti, müşteriye yazılmadı', renk: '#D97706', zemin: '#FFFBEB' },
  onlarda: { ad: 'Karşı tarafta',            kisa: 'Top müşteride, takip et', renk: '#436AEB', zemin: '#EEF2FF' },
  kontrol: { ad: 'Kontrol et',               kisa: 'Durumu mailden anlaşılmıyor', renk: '#7C3AED', zemin: '#F5F3FF' },
  kapandi: { ad: 'Kapandı',                  kisa: 'Teslim edildi', renk: '#059669', zemin: '#ECFDF5' },
};
const SIRA = ['bizde', 'bildir', 'onlarda', 'kontrol', 'kapandi'];
const ONCELIK = { yuksek: 0, orta: 1, dusuk: 2 };

const gunOnce = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso)) / 86400000));
const tarihYaz = (iso) => new Date(iso).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
const gmailLink = (thread) => `https://mail.google.com/mail/u/efe@glowytics.com/#all/${thread}`;

async function cagir(yol = '', secenekler = {}) {
  const res = await apiFetch(`${API}${yol}`, { headers: { 'Content-Type': 'application/json' }, ...secenekler });
  const govde = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(govde.error || `HTTP ${res.status}`);
  return govde;
}

function Rozet({ durum }) {
  const d = DURUM[durum] || DURUM.kontrol;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 10px', borderRadius: 999, background: d.zemin, color: d.renk, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>
      <span style={{ width: 6, height: 6, borderRadius: 999, background: d.renk }} />{d.ad}
    </span>
  );
}

function Cip({ aktif, onClick, children }) {
  return (
    <button type="button" onClick={onClick} style={{
      padding: '6px 12px', borderRadius: 999, fontSize: 13, fontWeight: 500, cursor: 'pointer',
      border: `1px solid ${aktif ? T.mavi : T.cizgi}`, background: aktif ? T.mavi : T.kart, color: aktif ? '#fff' : T.metin2,
    }}>{children}</button>
  );
}

function TalepKarti({ t, onDurum }) {
  const gun = gunOnce(t.tarih);
  const acik = t.durum !== 'kapandi';
  return (
    <div style={{ background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, padding: 18, borderLeft: `4px solid ${(DURUM[t.durum] || DURUM.kontrol).renk}` }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <Rozet durum={t.durum} />
        <span style={{ fontSize: 12, color: T.metin3, background: T.cizgi2, padding: '3px 8px', borderRadius: 6 }}>{t.altMarka}</span>
        {t.oncelik === 'yuksek' && acik && (
          <span style={{ fontSize: 12, color: '#DC2626', fontWeight: 600 }}>Öncelikli</span>
        )}
        <span style={{ marginLeft: 'auto', fontSize: 12, color: acik && gun > 14 ? '#DC2626' : T.metin3, whiteSpace: 'nowrap' }}>
          {tarihYaz(t.tarih)} · {gun === 0 ? 'bugün' : `${gun} gün`}
        </span>
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, color: T.metin, marginBottom: 4 }}>{t.baslik}</div>
      <div style={{ fontSize: 12, color: T.metin3, marginBottom: 10 }}>{t.kimden}</div>
      <p style={{ fontSize: 14, lineHeight: 1.6, color: T.metin2, margin: 0 }}>{t.ozet}</p>
      {t.sonrakiAdim && acik && (
        <div style={{ display: 'flex', gap: 8, marginTop: 12, padding: '10px 12px', background: T.yuzey, borderRadius: 8, fontSize: 14, color: T.metin }}>
          <ArrowRight size={16} color={T.mavi} style={{ flexShrink: 0, marginTop: 2 }} />
          <span>{t.sonrakiAdim}</span>
        </div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10, marginTop: 14 }}>
        {t.thread && (
          <a href={gmailLink(t.thread)} target="_blank" rel="noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: T.mavi, textDecoration: 'none', fontWeight: 500 }}>
            <Mail size={14} /> Gmail'de aç
          </a>
        )}
        <select value={t.durum} onChange={(e) => onDurum(t.id, e.target.value)} aria-label="Durumu değiştir"
          style={{ marginLeft: 'auto', fontSize: 13, padding: '5px 8px', borderRadius: 8, border: `1px solid ${T.cizgi}`, color: T.metin2, background: T.kart }}>
          {SIRA.map((k) => <option key={k} value={k}>{DURUM[k].ad}</option>)}
        </select>
      </div>
    </div>
  );
}

export default function MarkaTalepleri() {
  const [markalar, setMarkalar] = useState(null);
  const [secili, setSecili] = useState(null);
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState(null);
  const [gorunum, setGorunum] = useState('acik'); // acik | tumu | kapandi
  const [altMarka, setAltMarka] = useState('Tümü');

  useEffect(() => {
    cagir('').then((j) => {
      setMarkalar(j.markalar);
      if (j.markalar.length) setSecili(j.markalar[0].slug);
    }).catch((e) => setHata(e.message));
  }, []);

  useEffect(() => {
    if (!secili) return;
    setVeri(null); setAltMarka('Tümü');
    cagir(`/${secili}`).then(setVeri).catch((e) => setHata(e.message));
  }, [secili]);

  const sayac = useMemo(() => {
    const s = Object.fromEntries(SIRA.map((k) => [k, 0]));
    (veri?.talepler || []).forEach((t) => { if (s[t.durum] !== undefined) s[t.durum] += 1; });
    return s;
  }, [veri]);

  const liste = useMemo(() => {
    let l = veri?.talepler || [];
    if (gorunum === 'acik') l = l.filter((t) => t.durum !== 'kapandi');
    if (gorunum === 'kapandi') l = l.filter((t) => t.durum === 'kapandi');
    if (altMarka !== 'Tümü') l = l.filter((t) => t.altMarka === altMarka);
    return [...l].sort((a, b) =>
      SIRA.indexOf(a.durum) - SIRA.indexOf(b.durum)
      || (ONCELIK[a.oncelik] ?? 3) - (ONCELIK[b.oncelik] ?? 3)
      || new Date(a.tarih) - new Date(b.tarih));
  }, [veri, gorunum, altMarka]);

  const altMarkalar = useMemo(() => ['Tümü', ...new Set((veri?.talepler || []).map((t) => t.altMarka))], [veri]);

  const durumDegistir = async (id, durum) => {
    const eski = veri;
    setVeri((v) => ({ ...v, talepler: v.talepler.map((t) => (t.id === id ? { ...t, durum } : t)) }));
    try {
      await cagir(`/${secili}/${id}`, { method: 'PATCH', body: JSON.stringify({ durum }) });
    } catch (e) {
      setVeri(eski);
      setHata(`Durum kaydedilemedi: ${e.message}`);
    }
  };

  return (
    <div style={{ padding: '24px 16px', maxWidth: 1240, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 4 }}>
        <div style={{ width: 40, height: 40, borderRadius: 10, background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Inbox size={20} color={T.mavi} />
        </div>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: T.metin, margin: 0 }}>Marka Talepleri</h1>
          <div style={{ fontSize: 13, color: T.metin3 }}>Markalardan gelen mailler, bekleyen işler olarak</div>
        </div>
      </div>

      {hata && <div style={{ margin: '16px 0', padding: 12, borderRadius: 8, background: '#FEF2F2', color: '#B91C1C', fontSize: 14 }}>{hata}</div>}

      {markalar && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, margin: '20px 0' }}>
          {markalar.map((m) => {
            const acikSayi = m.sayac.bizde + m.sayac.bildir;
            const aktif = m.slug === secili;
            return (
              <button key={m.slug} type="button" onClick={() => setSecili(m.slug)} style={{
                display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 16px', borderRadius: 10, cursor: 'pointer',
                border: `1px solid ${aktif ? T.mavi : T.cizgi}`, background: aktif ? '#EEF2FF' : T.kart, color: aktif ? T.mavi : T.metin2, fontWeight: 600, fontSize: 14,
              }}>
                {m.marka}
                {acikSayi > 0 && <span style={{ background: '#DC2626', color: '#fff', borderRadius: 999, fontSize: 11, padding: '1px 7px' }}>{acikSayi}</span>}
              </button>
            );
          })}
          {markalar.length === 0 && <div style={{ color: T.metin3, fontSize: 14 }}>Henüz marka yok.</div>}
        </div>
      )}

      {!veri && !hata && secili && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: T.metin3, fontSize: 14 }}><RefreshCw size={14} /> Yükleniyor…</div>
      )}

      {veri && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginBottom: 16 }}>
            {SIRA.filter((k) => k !== 'kapandi').map((k) => (
              <div key={k} style={{ background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, padding: 16 }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: DURUM[k].renk, lineHeight: 1 }}>{sayac[k]}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: T.metin, marginTop: 8 }}>{DURUM[k].ad}</div>
                <div style={{ fontSize: 12, color: T.metin3, marginTop: 2 }}>{DURUM[k].kisa}</div>
              </div>
            ))}
          </div>

          <style>{`.mt-izgara{display:grid;grid-template-columns:minmax(0,1fr);gap:16px}@media(min-width:1024px){.mt-izgara{grid-template-columns:minmax(0,1fr) 300px}}`}</style>
          <div className="mt-izgara">
            <div style={{ minWidth: 0 }}>
              <div style={{ background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, padding: 18, marginBottom: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: T.metin3, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 6 }}>Özet</div>
                <p style={{ fontSize: 15, lineHeight: 1.6, color: T.metin, margin: 0 }}>{veri.ozet}</p>
                <div style={{ fontSize: 12, color: T.metin3, marginTop: 10 }}>
                  {veri.kaynak} · güncellendi {new Date(veri.guncellendi).toLocaleString('tr-TR', { dateStyle: 'medium', timeStyle: 'short' })}
                </div>
              </div>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
                <Cip aktif={gorunum === 'acik'} onClick={() => setGorunum('acik')}>Açık ({veri.talepler.length - sayac.kapandi})</Cip>
                <Cip aktif={gorunum === 'kapandi'} onClick={() => setGorunum('kapandi')}>Kapanan ({sayac.kapandi})</Cip>
                <Cip aktif={gorunum === 'tumu'} onClick={() => setGorunum('tumu')}>Tümü ({veri.talepler.length})</Cip>
              </div>
              {altMarkalar.length > 2 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                  {altMarkalar.map((a) => <Cip key={a} aktif={altMarka === a} onClick={() => setAltMarka(a)}>{a}</Cip>)}
                </div>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {liste.map((t) => <TalepKarti key={t.id} t={t} onDurum={durumDegistir} />)}
                {liste.length === 0 && <div style={{ color: T.metin3, fontSize: 14, padding: 20, textAlign: 'center' }}>Bu filtrede talep yok.</div>}
              </div>
            </div>

            {veri.kisiler?.length > 0 && (
              <aside style={{ background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, padding: 18, alignSelf: 'start' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 600, color: T.metin, marginBottom: 12 }}>
                  <Users size={16} color={T.mavi} /> Kişiler
                </div>
                {veri.kisiler.map((k) => (
                  <div key={k.ad} style={{ padding: '10px 0', borderTop: `1px solid ${T.cizgi2}` }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: T.metin }}>{k.ad}</div>
                    <div style={{ fontSize: 12, color: T.metin3, marginTop: 2 }}>{k.rol}</div>
                    {k.eposta && <a href={`mailto:${k.eposta}`} style={{ fontSize: 12, color: T.mavi, textDecoration: 'none', wordBreak: 'break-all' }}>{k.eposta}</a>}
                  </div>
                ))}
              </aside>
            )}
          </div>
        </>
      )}
    </div>
  );
}
